module.exports = __webpack_public_path__ + "img/iphonex.85b6ca2c.png";